// extracted by mini-css-extract-plugin
export default {"root":"_4ZSJv","hero":"_7ELZd","subheading":"IKoVP","social":"_0dZtb","bluesky":"SYEJU","linkedin":"TMgh5","scroll":"IXvY2"};